export default "__VITE_ASSET__d_7tIPjq__"